import { useMapData } from '@/pages/dashboard/utils/customHook';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Checkbox, Dropdown, SearchBox } from 'tea-component';
import { getLocale, useIntl } from 'umi';

import './index.scss';
import useSearch from '@/pages/dashboard/components/SelectorMultiple/hooks/useSearch';
import NoData from '@/pages/dashboard/components/SelectorMultiple/components/NoData';

const MultipleChoice = (props: any) => {
  const { value, options, onChange,isPoeFunnel, defualtLockValue, className, name } = props;
  const { formatMessage } = useIntl();
  const {
    searchValue,
    // setSearchValue,
    // replaceMatch,
    buildHighLightData,
    handleSearchValueChange,
  } = useSearch(options);
  const renderOptions = buildHighLightData() ?? [];

  const bindClassName = useRef(
    `selector${  Math.round(Math.random() * 10000 * Date.now()).toString(16)}`,
  );
  const allValue = useMapData(options, 'value', [options]);
  const [isAll, setIsAll] = useState(true);
  const selectAll = () => {
    const flag = value?.length !== allValue?.length;
    onChange(flag ? allValue : [defualtLockValue]);
  };

  useEffect(() => {
    setIsAll(value?.length !== allValue?.length);
  }, [value]);

  const filterName= useMemo(()=>{
    if(name){
      return name;
    }
    return isPoeFunnel ? formatMessage({ id: 'funnel_channel_step_poe' }) : formatMessage({ id: 'funnel_step' });
  },[formatMessage, isPoeFunnel, getLocale(), name]);

  return <Dropdown
    className={`select-dashboard-box ${bindClassName.current} ${className}`}
    boxClassName="selector-multiple__dropdown"
    overlayClassName={'selector-multiple__dropdown-overlay'}
    appearance="button"
    clickClose={false}
    closeOnScroll={false}
    positionFixed={false}
    popupContainer={() =>
      document.querySelector(`.${bindClassName.current}`)
    }
    onClose={() => {
      // setSearchValue('')
    }}
    button={
      <div className="select-button">
        <div className="select-button-text">{filterName}</div>
        {value?.length != 0
          ? value?.length > 1
            ? value?.length
            : options?.filter((e: any) => e?.value == value?.[0])[0]?.text
          : ''}
      </div>
    }
  >
    {() => (
      <>
        <SearchBox
          placeholder={formatMessage({ id: 'selector_multiple_component_placeholder' })}
          className="selector-multiple-search-input"
          onChange={handleSearchValueChange}
          value={searchValue}
        />
        <div className="selector-multiple__dropdown-inner">
          <div className="select-context">
            {
              !searchValue && <div className="select-felx">
                <span className="select-felx-lf">{isPoeFunnel ? formatMessage({ id: 'funnel_channel_step_poe' }) : formatMessage({ id: 'funnel_step' })}</span>
                <span className="select-felx-rt"
                  onClick={selectAll}
                >
                  {isAll ? formatMessage({ id: 'selector_multiple_component_select_all' }) : formatMessage({ id: 'selector_multiple_component_clear_all' })}
                </span>
              </div>
            }
          </div>
          {searchValue && renderOptions?.length === 0 ? <NoData /> :
            <div className="list-container">
              <div className="tea-form-checks">
                <Checkbox.Group
                  layout="column"
                  value={value}
                  className="list"
                  onChange={(value) => onChange(value)}
                >
                  {renderOptions?.map((item: any) => (
                    <Checkbox key={item.value} name={item.value} disabled={item?.disabled}>
                      {item.icon && <img src={item.icon} />}
                      <span className='dbd-step-select-options-item-text'
                        dangerouslySetInnerHTML={{ __html: `${item.text}` }}
                      />
                      {item?.default && <span className="dbd-step-select-dropdown-icon">*</span>}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
              </div>
            </div>
          }
        </div>
        <div className="tea-dropdown-box__footer">
          <div className="dbd-step-select-footer">
            <span className="dbd-step-select-footer-icon">*</span>
            {formatMessage({ id: 'funnel_inevitable_step' })}
          </div>
        </div>
      </>
    )}
  </Dropdown>;
};

export default MultipleChoice;
